import { Route, Routes, useLocation } from 'react-router-dom';
import ErrorPage from './Pages/404/404';
import AboutUs from './Pages/AboutUs/AboutUs';
import LandingPage from './Pages/LandingPage/LandingPage';
import Membership from './Containers/Membership/Membership';
import ForOrganizations from './Pages/ForOrganizations/ForOrganizations';
import Blog from './Pages/Blog/Blog';
import BlogPages from './Pages/BlogPage/BlogPage';
import YSFPage from './Pages/YSFPage/YSFPage';
import YSF26 from './Pages/YSF26/YSF26';
import GMWPage from './Pages/GMWPage/GmwHome';
import GMW2026 from './Pages/GMW2026/Gmw2026Home';
import IYDHome from './Pages/IYD/IydHome';
import OgxPage from './Pages/OgxPage/OgxPage';
import FormPage from './Pages/ExchangeForm/FormPage';
import { ConfigProvider } from 'antd';
import { Helmet } from 'react-helmet-async';
import LeadershipSummitPage from './Pages/LeadershipSummit/LeadershipHome';
import LeadershipSummitRegisterPage from './Pages/LeadershipSummitRegister/LeadershipSummitRegisterHome';
import NvHome from './Pages/NvHome/NvHome';
import NvProjects from './Pages/NvProjects/NvProjects';
import NvSignUp from './Containers/NvSignUp/NvSignUp';
import NvStatesForm from './Containers/NvStatesForm/NvStatesForm';
import './fonts/Expose-Regular.ttf';
import LocalCommitteePages from './Pages/LocalCommitteePages/LocalCommitteePages';
import CookieConsentApp from './Components/Cookies/CookieConsentApp';
import { useCookies } from 'react-cookie';
import WACS from './Pages/WACS/WACS';
import WACSRegister from './Pages/WACSRegister/WACSRegister';
import PreLandingPopup from './Components/PreLandingPopup/PreLandingPopup';
import { useEffect, useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
function App() {
  const [cookies] = useCookies(['cookieConsent']);
  const location = useLocation();
  const [showPreLandingPopup, setShowPreLandingPopup] = useState(false);
  const PRE_LANDING_POPUP_VERSION = 'v2';

  const queryClient = new QueryClient();

  useEffect(() => {
    const hasSeenPopup =
      localStorage.getItem('preLandingPopupVersion') ===
      PRE_LANDING_POPUP_VERSION;
    const shouldShowPopup =
      cookies.cookieConsent && location.pathname === '/' && !hasSeenPopup;

    setShowPreLandingPopup(shouldShowPopup);
  }, [cookies.cookieConsent, location.pathname, PRE_LANDING_POPUP_VERSION]);

  const handleContinueFromPreLandingPopup = () => {
    localStorage.setItem('preLandingPopupVersion', PRE_LANDING_POPUP_VERSION);
    setShowPreLandingPopup(false);
  };

  return (
    <>
    <QueryClientProvider client={queryClient}>
        <Helmet>
          {/* <!-- Primary Meta Tags --> */}
          <title>AIESEC in Nigeria</title>
          <meta name="title" content="AIESEC in Nigeria" />
          <meta name="description" content="AIESEC in Nigeria" />

          {/* <!-- Open Graph / Facebook --> */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://aiesec.ng" />
          <meta property="og:title" content="AIESEC in Nigeria" />
          <meta property="og:description" content="AIESEC in Nigeria" />
          <meta
            property="og:image"
            content="https://res.cloudinary.com/skycoder/image/upload/v1715860313/logo_ih0mgq.png"
          />

          {/* <!-- Twitter --> */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content="https://aiesec.ng" />
          <meta property="twitter:title" content="AIESEC in Nigeria" />
          <meta property="twitter:description" content="AIESEC in Nigeria" />
          <meta
            property="twitter:image"
            content="https://res.cloudinary.com/skycoder/image/upload/v1715860313/logo_ih0mgq.png"
          />
        </Helmet>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: 'Lato, sans-serif',
            },
          }}
        >
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<ErrorPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/membership" element={<Membership />} />
            <Route
              path="/local-committee/:localCommittee"
              element={<LocalCommitteePages />}
            />
            <Route path="/for-organizations" element={<ForOrganizations />} />
            {/* <Route path="/ysf" element={<YSFPage />} /> */}
            <Route path="/ysf" element={<YSF26 />} />
            <Route path="/gmw" element={<GMWPage />} />
            <Route path="/gmw/registration" element={<GMW2026 />} />
            <Route path="LeadershipSummit" element={<LeadershipSummitPage />} />
            <Route
              path="LeadershipSummit/register"
              element={<LeadershipSummitRegisterPage />}
            />
            <Route path="/iyd" element={<IYDHome />} />
            <Route path="/ogx" element={<OgxPage />} />
            <Route path="/ogx/apply" element={<FormPage />} />
            <Route path="/wacs" element={<WACS />} />
            <Route path="/wacs/register" element={<WACSRegister />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPages />} />
            <Route path="/nv" element={<NvHome />} />
            <Route path="/nv/projects" element={<NvProjects />} />
            <Route path="/nv/sign-up" element={<NvSignUp />} />
            <Route path="/nv/sign-up/:city" element={<NvStatesForm />} />
          </Routes>
          {showPreLandingPopup && location.pathname === '/' && (
            <PreLandingPopup onContinue={handleContinueFromPreLandingPopup} />
          )}
          {!cookies.cookieConsent && <CookieConsentApp />}
        </ConfigProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
